import React from "react";
import BuffersCard from "./CommandPanel/BuffersCard";
import GargaloCard from "./CommandPanel/GargaloCard";
import NextActionCard from "./CommandPanel/NextActionCard";
import ThroughputCard from "./CommandPanel/ThroughputCard";
import { CommandGrid } from "./styles";

export default function CommandPanel({
  toc,
  calibracaoCompleta,
  precosVisiveis,
  nextAction,
  onScrollCriticos,
}) {
  return (
    <CommandGrid>
      <GargaloCard
        toc={toc}
        calibracaoCompleta={calibracaoCompleta}
        precosVisiveis={precosVisiveis}
      />
      <BuffersCard
        contagemPorZona={toc?.contagemPorZona}
        onVerCriticos={onScrollCriticos}
      />
      <ThroughputCard
        throughput={toc?.throughput}
        historico={toc?.historicoT}
        precosVisiveis={precosVisiveis}
      />
      <NextActionCard
        nextAction={nextAction}
        onScrollCriticos={onScrollCriticos}
      />
    </CommandGrid>
  );
}
